import React, { useEffect, useState } from 'react';
import {  Container, useTheme } from '@mui/material';
import LayoutComponent from '@/components/LayoutComponent';
import { layoutService } from '@/services/layout-service';
import LayoutSkeleton from '@/components/LayoutComponent/layoutSkeleton';
import GenericErrorScreen from '@/components/ErrorScreen';
import Footer from '@/components/unlmtd/Footers';
import { dataLayerPushWithEvent } from '@/utils/callcustomevent';
import { useUser } from '@/hooks/useUser';
import { useLocation } from '@/hooks/useLocation';


const Home = () => {
	const theme = useTheme();
	const [layoutData, setLayoutData] = useState<any>();
	const [errored, setErrored] = useState(false);
	const {user} = useUser();
	const {selectedLocation} = useLocation();

	useEffect(() => {
		layoutService
			.getLayout('UNLMTD_HOME_WEB')
			.then((res: any) => {
				setLayoutData(res.data.data);
			})
			.catch(() => {
				setErrored(true);
			});
	}, [user,selectedLocation]);
	useEffect(() => {
		dataLayerPushWithEvent('UNLMTD Home Page Loaded',{
			
		})
		dataLayerPushWithEvent('moe_event', {
			moe_event_name: 'UNLMTD Home Page Loaded',
			moe_event_data: {
				trackingUrl: window?.location?.href,
			},
		});
	}, []);
	
	return (
		<>

			<Container maxWidth='xl' sx={{ margin: '0 auto', padding: '0 32px',background:"#222038" }}>
				{!errored ? (
					layoutData ? (
						<LayoutComponent {...layoutData} />
					) : (
						<LayoutSkeleton />
					)
				) : (
					<GenericErrorScreen />
				)}
			</Container>
			<Footer />
		</>
	);
};

export default Home;
